import { Box, Stack, Typography } from '@mui/material';

export default function DonutLegendItem({ item }) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={1}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ minWidth: 0 }}
      >
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: item.color,
            flexShrink: 0,
          }}
        />

        <Typography
          variant="subtitle1"
          sx={{
            minWidth: 0,
            fontSize: '.8rem',
            fontWeight: 500,
            overflowWrap: 'anywhere',
          }}
        >
          {item.name}
        </Typography>
      </Stack>

      <Typography
        variant="subtitle1"
        sx={{
          fontSize: '.8rem',
          fontWeight: 500,
          whiteSpace: 'nowrap',
        }}
      >
        {item.value} ({item.percentage}%)
      </Typography>
    </Stack>
  );
}
